import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appToggleOption]',
  standalone: true
})
export class ToggleButtonOptionDirective {
  private _value!: string;
  private _label!: string;
  
  @Input() 
  set appToggleOption(value: string) {
    this._value = value;
  }
  
  get appToggleOption(): string {
    return this._value;
  }
  
  @Input('appToggleOptionLabel')
  set label(value: string) {
    this._label = value;
  }
  
  get label(): string {
    return this._label || '';
  }

  constructor(public templateRef: TemplateRef<any>) {}
}